import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { formatCurrencyShort, formatMonth } from '../lib/format.js';

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-lg shadow-lg border border-slate-200 px-3 py-2 text-xs">
      <p className="font-semibold text-slate-700 mb-1 capitalize">{label}</p>
      {payload.map((p) => (
        <p key={p.name} style={{ color: p.color }}>
          {p.name}: {formatCurrencyShort(p.value * 100)}
        </p>
      ))}
    </div>
  );
}

export default function MonthlyChart({ data = [], categories = [] }) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-48 text-sm text-slate-400">
        Pas de données
      </div>
    );
  }

  // Aggregate data per month
  const chartData = data.map((row) => {
    const totalRealized = (row.by_category ?? []).reduce(
      (sum, c) => sum + (c.realized_cents ?? 0),
      0
    );
    const totalBudget = (row.by_category ?? []).reduce(
      (sum, c) => sum + (c.budget_cents ?? 0),
      0
    );
    return {
      name: formatMonth(row.year, row.month).slice(0, 3),
      realized: Math.round(totalRealized / 100),
      budget: Math.round(totalBudget / 100),
    };
  });

  return (
    <ResponsiveContainer width="100%" height={200}>
      <AreaChart data={chartData} margin={{ top: 4, right: 4, bottom: 0, left: -10 }}>
        <defs>
          <linearGradient id="gradRealized" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#475569" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#475569" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="gradBudget" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#94a3b8" stopOpacity={0.15} />
            <stop offset="95%" stopColor="#94a3b8" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis dataKey="name" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
        <YAxis
          tickFormatter={(v) => formatCurrencyShort(v * 100)}
          tick={{ fontSize: 11 }}
          tickLine={false}
          axisLine={false}
          width={56}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ fontSize: '11px', paddingTop: '8px' }}
          formatter={(v) => (v === 'realized' ? 'Réalisé' : 'Budget')}
        />
        <Area
          type="monotone"
          dataKey="budget"
          stroke="#94a3b8"
          strokeWidth={1.5}
          strokeDasharray="4 2"
          fill="url(#gradBudget)"
        />
        <Area
          type="monotone"
          dataKey="realized"
          stroke="#475569"
          strokeWidth={2}
          fill="url(#gradRealized)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
